import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

const LengthMin = withFilterContext(FilterName.min_exterior_length, SearchFiltersDropdown, {
    ...rangeMin,
    ariaLabel: ariaLabel.length.min,
})
const LengthMax = withFilterContext(FilterName.max_exterior_length, SearchFiltersDropdown, {
    ...rangeMax,
    ariaLabel: ariaLabel.length.max,
})

export const LengthMinFacetAndFilter = withFacetContext(FacetName.exterior_length, LengthMin)
export const LengthMaxFacetAndFilter = withFacetContext(FacetName.exterior_length, LengthMax)
